// extracted by mini-css-extract-plugin
export var screen1 = "style-module--screen1--631c9";
export var screen1__btn = "style-module--screen1__btn--ef9cc";
export var screen1__descriptionEl = "style-module--screen1__description-el--bc4e3";
export var screen1__info = "style-module--screen1__info--70ce3";
export var screen1__subtitle = "style-module--screen1__subtitle--329ff";
export var screen1__title = "style-module--screen1__title--a708d";